import { LoadDocxByFinalStoryMeta, LoadDocxByFinalStoryPayload } from 'types/store/LoadDocxByFinalStory';
import { createAsyncReducer } from 'utils/Redux';

import { loadDocxByFinalStoryActions } from '../actions';

export default createAsyncReducer<LoadDocxByFinalStoryMeta, LoadDocxByFinalStoryPayload>(loadDocxByFinalStoryActions);
